module.exports = __webpack_public_path__ + "static/media/mobileScreenshot11.b03a0a0e.jpg";